export default function Button(opts){
    let container = opts.container
    BaseConstructor.call(this)
    let elements = {}
    let context = this
    init()

    function init() {
        elements.button = context.createElement('button', 'btn btn-sm btn-outline-danger', 'Adicionar Gráfico')
        elements.button.type = 'button'
        $(container).append(elements.button)

        eventsHandler()
    }

    function eventsHandler(){
        $(elements.button).on('click', () =>{
            context.trigger('click')
        })
    }
}

Button.prototype = Object.create(BaseConstructor.prototype)